import React from 'react';
import Scroll from 'react-scroll';
import RegEx from '../../util/RegEx';

import FieldSingleAddressItem from './FieldSingleAddressItem';
import Const from '../../util/Constants';
import FieldLocation from './FieldLocation';
class FieldSingleAddress extends React.Component {
  
  constructor(props) {
    super(props);
    this.LabelName = props.field.label_name;
    this.regex = props.field.validate;
    this.values = (!props.value || props.value.length === 0) ? [{}] : props.value;
    this.state = { changed: false, inValid: props.inValid ? props.inValid : {}, values: this.values
    };

    this.visible = props.field.visible === Const.True;
    this.editable = props.field.editable === Const.True;
  }

  UNSAFE_componentWillReceiveProps(props) {
    if(JSON.stringify(this.state.inValid) !== JSON.stringify(props.inValid)) {
      this.setState({ ...this.state, inValid: props.inValid ? props.inValid : {} });
    }
    
    // Update values when props change
    if (props.value && JSON.stringify(this.state.values) !== JSON.stringify(props.value)) {
      const safeValues = (!props.value || props.value.length === 0)
      ? [{}]
      : props.value;

    this.values = safeValues;

    this.setState({
      values: safeValues,
      changed: !this.state.changed
    });

    }
  }
  
  onAdd = () => {
    this.values.push({ });
    this.setState({ ...this.state, changed: !this.state.changed });
    this.props.onValueChange(this.props.id, this.values);
  }

  onDelete = index => {
    this.values = this.values.filter((_, i) => i !== index);
    this.setState({ ...this.state, changed: !this.state.changed });
    this.props.onValueChange(this.props.id, this.values);
  }

  onUpdate = (index, address) => {
    this.values[index] = {
      ...this.values[index],
      street: address.street || '',
      city: address.city ? address.city.value : 0,
      state: address.state ? address.state.value : 0,
      country: address.country ? address.country.value : 0,
      pin: address.pin || ''
    };
    
    this.props.onValueChange(this.props.id, this.values);
    this.setState({ ...this.state, changed: !this.state.changed });
  }

 render() {
  if(!this.visible || !this.editable) return null;

  let valueList = [];
  for (let i = 0; i < this.values.length; i++) {
    valueList.push(
      <FieldSingleAddressItem
        key={`mul_${this.props.id}_${i}`}
        index={i}
        value={this.values[i]}
        onAdd={this.onAdd}
        onDelete={this.onDelete}
        onUpdate={this.onUpdate}
      />
    );
  }

  return (
    <>
      <div className="formhead col-md-12">
        <h2>Address Information</h2>
      </div>

      {this.props.locationField && (
        <div className="row row-cols-3 addressdiv col-md-12">
          <FieldLocation id="location" field={this.props.locationField.field} value={this.props.locationField.value} onValueChange={this.props.locationField.onValueChange} inValid={this.props.inValid} />
        </div>
      )}
      <Scroll.Element name={this.props.id} />
      {RegEx.showError(this.state.inValid, this.props.id)}
      {valueList}
    </>
  );
}
}
export default FieldSingleAddress;